export const BENCHMARKING_DATA_TOOLTIP_WIDTH = '240px';
export const PROJECT_NAME_TOOLTIP_WIDTH = '240px';
export const RUN_OPM_INACTIVE_DROPDOWN_TOOLTIP_WIDTH = '400px';
